const branchschool = {
	path:'/branchschool',
	name: 'branchschool',
	component: () => import("@views/branch_school/branch_school.vue"),
	children:[
		/*{
			path:'index',
			component: () => import("@views/branch_school/index.vue"),
			meta: {
				tabBar: false
			}
		},*/
		{
			path:'first_license',
			component: () => import("@views/branch_school/first_license.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path:'second_license',
			component: () => import("@views/branch_school/second_license.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path:'thirdly_license',
			component: () => import("@views/branch_school/thirdly_license.vue"),
			meta: {
				tabBar: false,
				keepAlive:true
			}
		},
		{
			path:'students_help',
			component: () => import("@views/branch_school/students_help.vue"),
			meta: {
				tabBar: false
			}
		},
    {
      path:'my_help',
      component: () => import("@views/branch_school/my_help.vue"),
      meta: {
        tabBar: false
      }
    },
		{
			path:'invitation',
			component: () => import("@views/branch_school/invitation.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path:'application_success',
			component: () => import("@views/branch_school/application_success.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path:'assistance',
			component: () => import("@views/branch_school/assistance.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path:'driving_search',
			component: () => import("@views/branch_school/driving_search.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path:'modification_license',
			component: () => import("@views/branch_school/modification_license.vue"),
			meta: {
				tabBar: false,
				keepAlive:true
			}
		}
	]
};

export default branchschool
